import React from 'react';
import { Cut, Solid, Stroke } from './MenuGlyphs';

// Membership tier icons, in the house glyph style:
// solid silhouettes with fine details cut in, on a 24px grid.

type GlyphProps = {
  className?: string;
};
type Glyph = (p: GlyphProps) => JSX.Element;
const PrivateKey: Glyph = ({
  className
}) =>
// Private — an ornate house key with a quatrefoil bow
<Solid className={className} cuts={<>
        <circle cx="5.6" cy="12" r="1.25" data-id="element-1163" data-mp="erqgn2xc5zyz" />
        <circle cx="5.6" cy="12" r="2.6" fill="none" stroke="black" strokeWidth="0.45" data-id="element-1164" data-mp="euuqogxhfpxk" />
        <Cut d="M10.2 10.9V13.1" w={0.45} data-id="element-1165" data-mp="jpi8jwxzdm36" />
        <Cut d="M12.4 12H16.6" w={0.4} data-id="element-1166" data-mp="5slivytlmanv" />
      </>} data-id="element-1162" data-mp="sq6owyaujyj8">
    <circle cx="5.6" cy="8.8" r="2.5" data-id="element-1167" data-mp="5twj5onu50a8" />
    <circle cx="5.6" cy="15.2" r="2.5" data-id="element-1168" data-mp="9svqffx1h94u" />
    <circle cx="2.4" cy="12" r="2.1" data-id="element-1169" data-mp="9toyqlbnc6p3" />
    <circle cx="8.8" cy="12" r="2.1" data-id="element-1170" data-mp="2064ayt4v111s" />
    <circle cx="5.6" cy="12" r="3.2" data-id="element-1171" data-mp="2075z9zavzk1g" />
    <rect x="9.4" y="10.4" width="1.6" height="3.2" rx="0.4" data-id="element-1172" data-mp="20409ehufoe4o" />
    <rect x="10.8" y="11.25" width="11" height="1.5" rx="0.5" data-id="element-1173" data-mp="246531gkvtarb" />
    <path d="M17.2 12.6H18.8V15.2H17.2Z" data-id="element-1174" data-mp="2a6arq99sq0l1" />
    <path d="M19.6 12.6H21.8V16.4H20.8V15.2H19.6Z" data-id="element-1175" data-mp="2a583k93uyc8t" />
  </Solid>;
const CorporateCase: Glyph = ({
  className
}) =>
// Corporate — a stitched leather attaché with brass clasps
<Solid className={className} cuts={<>
        <Cut d="M2.4 12H21.6" w={0.7} data-id="element-1177" data-mp="2exizz1ze3fwm" />
        <rect x="4" y="9.1" width="16" height="10" rx="0.8" fill="none" stroke="black" strokeWidth="0.45" strokeDasharray="0.9 0.8" data-id="element-1178" data-mp="2eykfbinfuok5" />
        <rect x="6.2" y="10.8" width="2.4" height="2.6" rx="0.4" data-id="element-1179" data-mp="1ra152xktw1pf" />
        <rect x="15.4" y="10.8" width="2.4" height="2.6" rx="0.4" data-id="element-1180" data-mp="1m9wvzsm92998" />
        <rect x="6.8" y="11.4" width="1.2" height="1.4" rx="0.2" fill="white" data-id="element-1181" data-mp="215utbe7wtjn1" />
        <rect x="16" y="11.4" width="1.2" height="1.4" rx="0.2" fill="white" data-id="element-1182" data-mp="213rtk2gygc54" />
      </>} extra={<Stroke d="M9 7.6V5.7C9 5 9.5 4.5 10.2 4.5H13.8C14.5 4.5 15 5 15 5.7V7.6" w={1.4} data-id="element-1183" data-mp="1w9e22b5eyp5q" />} data-id="element-1176" data-mp="2jvkinlswld7k">
    <rect x="2.4" y="7.6" width="19.2" height="13" rx="1.6" data-id="element-1184" data-mp="3cn499qrtxtjl" />
  </Solid>;
const EditorialNib: Glyph = ({
  className
}) =>
// Editorial — an engraved fountain-pen nib
<Solid className={className} cuts={<>
        <circle cx="12" cy="13.2" r="1.1" data-id="element-1186" data-mp="3jnyba6svq7h0" />
        <Cut d="M12 14.4V21.4" w={0.6} data-id="element-1187" data-mp="3jmwr9ctvyan5" />
        <Cut d="M9.6 11.2C10.6 12 10.4 14.2 11.1 16.2" w={0.45} data-id="element-1188" data-mp="3onu4rc3yagib" />
        <Cut d="M14.4 11.2C13.4 12 13.6 14.2 12.9 16.2" w={0.45} data-id="element-1189" data-mp="3ooc78qh7hqyo" />
        <Cut d="M9.4 7H14.6" w={0.45} data-id="element-1190" data-mp="3tlm955ls7v3e" />
        <Cut d="M8.4 4.9H15.6" w={0.6} data-id="element-1191" data-mp="3tkktsoxqgmfv" />
      </>} extra={<Stroke d="M14.6 22.5H20.4" w={0.9} opacity={0.5} data-id="element-1192" data-mp="2vzyaee1ut0op" />} data-id="element-1185" data-mp="3eov52j15xv7g">
    <rect x="8.6" y="1.4" width="6.8" height="3.8" rx="0.7" data-id="element-1193" data-mp="30xzvt5mr5c3c" />
    <path d="M12 22.6L7.2 13.2C6.8 12.4 7 11.4 7.6 10.8L9.4 9.2V5.2H14.6V9.2L16.4 10.8C17 11.4 17.2 12.4 16.8 13.2Z" data-id="element-1194" data-mp="30y9les3vxh8i" />
  </Solid>;
const tierGlyphs: Record<string, Glyph> = {
  Private: PrivateKey,
  Corporate: CorporateCase,
  Editorial: EditorialNib
};
export function TierIcon({
  tier,
  className
}: {
  tier: string;
  className?: string;
}) {
  const G = tierGlyphs[tier];
  return G ? <G className={className} data-id="element-1195" data-mp="2i6791sya0n42" /> : null;
}